import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'

export const useUserRoles = () => {
  const user = useSelector(selectUser)
  const roles = user.roleIds

  const isPartnerUser = useMemo(() => {
    return roles.some((role) => role === 'Partner User')
  }, [roles])

  const isSuperAdmin = useMemo(() => {
    return roles.some((role) => role === 'SuperAdmin')
  }, [roles])

  const isAMSPartnerCreator = useMemo(
    () => roles.some((role) => role === 'AMS Partner creator'),
    [roles]
  )

  const isP360Tester = useMemo(() => {
    return roles.some((role) => role === 'P360Tester')
  }, [roles])

  const isCCDeveloper = useMemo(() => {
    return roles.some((role) => role === 'CC Developer')
  }, [roles])

  return {
    roles,
    isPartnerUser,
    isSuperAdmin,
    isAMSPartnerCreator,
    isP360Tester,
    isCCDeveloper,
  }
}
